import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError, switchMap, catchError } from 'rxjs';
import { JwtTokenService } from '@shared/auth/services/jwt-token.service';
import { AuthService } from '@shared/auth/services/auth.service';
import { Endpoints } from '@core/constants/endpoints.constant';

const LOGOUT_ON_403_URLS = [Endpoints.auth.login, Endpoints.auth.register];

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const tokenService = inject(JwtTokenService);
  const authService = inject(AuthService);

  const accessToken = tokenService.getAccessToken();
  const authReq = accessToken ? req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 && LOGOUT_ON_403_URLS.some(url => req.url.includes(url))) {
        authService.logout();
        return throwError(() => error);
      }

      if (error.status !== 401) return throwError(() => error);

      const refreshToken = tokenService.getRefreshToken();
      if (!refreshToken) {
        authService.logout();
        return throwError(() => error);
      }

      return authService.refreshAccessToken().pipe(
        switchMap(resp => {
          if (!resp?.accessToken) {
            authService.logout();
            return throwError(() => error);
          }
          const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${resp.accessToken}` } });
          return next(retryReq);
        })
      );
    })
  );
};
